import { render } from "./NearbySalesChart.vue?vue&type=template&id=2b52e6b2&ts=true"
import script from "./NearbySalesChart.vue?vue&type=script&lang=ts"
export * from "./NearbySalesChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__